import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class DepartMentService {

    constructor(private http: HttpClient) { }

    getDeptWithCount(body: any): Observable<any> {
        return this.http.post(environment.getAllDepartmentWithCount, body);
    }

    createDepartment(body: any): Observable<any> {
        return this.http.post(environment.createDepartment, body);
    }

    updateDepartment(body: any): Observable<any> {
        return this.http.post(environment.updateDepartment, body);
    }

    deleteDepartment(body: any): Observable<any> {
        return this.http.post(environment.deleteDepartment, body);
    }
    
}
